import * as SplitUnbilledBalanceActions from './../actions/split-unbilled-balence.actions';
import { TechnicalError } from '@dch/products-business-logic';

export interface SplitUnbilledBalanceState {
  _embedded: any;
  splitUnbilledBalance: any;
  isPending: boolean;
  error: TechnicalError;
}

export const initialState: SplitUnbilledBalanceState = {
  _embedded: null,
  splitUnbilledBalance: null,
  isPending: false,
  error: null,
};

export const getSplitUnbilledBalance = (
  state: SplitUnbilledBalanceState,
): any => {
  return state.splitUnbilledBalance;
};
export const getEmbeddedErrors = (state: SplitUnbilledBalanceState) =>
  state._embedded && state._embedded.errors;

export const getTechnicalError = (state: SplitUnbilledBalanceState) =>
  state.error;

export const getPending = (state: SplitUnbilledBalanceState) => state.isPending;

export function reducer(
  state: SplitUnbilledBalanceState = initialState,
  action: SplitUnbilledBalanceActions.Actions,
): SplitUnbilledBalanceState {
  switch (action.type) {
    case SplitUnbilledBalanceActions.GET_SPLIT_UNBILLED_BALANCE:
      return {
        ...state,
        isPending: true,
        error: null,
      };
    case SplitUnbilledBalanceActions.GET_SPLIT_UNBILLED_BALANCE_SUCCESS:
      return {
        ...state,
        _embedded: action.payload._embedded,
        splitUnbilledBalance: action.payload,
        isPending: false,
        error: null,
      };
    case SplitUnbilledBalanceActions.GET_SPLIT_UNBILLED_BALANCE_FAILED:
      return {
        ...state,
        error: action.payload,
        isPending: false,
      };

    default:
      return state;
  }
}
